export class FlagsHelper {

   // flags helper
   public static isFlagSet(val: number, flag: number): boolean { return (val & flag) !== 0; }
   public static setFlag(val: number, flag: number, set: boolean): number {
      if (set) { return val |= flag; } else { return val &= ~flag; }
   }
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/library/flags-helper.ts